import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '~/common/components/ui/dropdown-menu';
import { LucideChevronDown, MapPin } from 'lucide-react';
import { cn } from '~/common/utils/styleUtil';
import { NavDropDownMenuItem } from '~/shell/components/NavDropDownMenuItem';
import { useState } from 'react';
import { useLocations } from '~/shell/routes/resources/CcLocationsRoute';

export function ShopLocationSelector() {
  const [open, setOpen] = useState(false);
  const { locations, ccId, setCcId } = useLocations();

  if (locations.length == 0) {
    return null;
  }

  const iconSize = 14;

  const selectedLocation = locations?.find(location => location.id === ccId);

  return (
    <>
      <span className={'text-secondary'}>|</span>
      <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
        <DropdownMenuTrigger data-testid={'location-selector'}>
          <div
            className={cn(
              'flex items-center gap-1 text-secondary cursor hover:text-primary focus:text-primary',
              open && 'text-primary-dark'
            )}
          >
            <MapPin size={iconSize} />
            <div>
              <div>{selectedLocation?.text}</div>
            </div>
            <div>
              <LucideChevronDown size={14} className={cn(open && 'rotate-180')} />
            </div>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent className={'p-4 max-h-[350px] overflow-y-auto'}>
          {locations?.map(location => {
            return (
              <NavDropDownMenuItem
                key={location.id}
                onClick={() => setCcId(location.id)}
                data-testid={`location-${location.id}`}
              >
                {location.text}
              </NavDropDownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
